import { ActivityParameter } from 'runtime/data/activityparameter';

export class ActivityFileParameter extends ActivityParameter {
    input: HTMLInputElement;

    constructor(name: string, input: HTMLInputElement) {
        super(name, '');
        this.input = input;
    }
}